import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { CourseMasterError, SharedColumns } from 'src/utils/courseMasterError';

import { courseLabel } from './courseMasterUtils';

type Mismatch = Extract<CourseMasterError, { code: 'trip_group_mismatch' }>;
type Props = { mismatch: Mismatch | null; selfLabel: string; onChoose: (align: 'self' | 'target') => void; onClose: () => void };

const describe = (c: SharedColumns) =>
  [c.defaultTruck?.licensePlateValue ?? '車両なし', c.defaultDriver?.name ?? 'ドライバーなし', c.partnerCompany?.name ?? '運送会社なし'].join('・');

/** 2 便を 1 便に紐付けるとき車両・ドライバー・運送会社がずれていたら、どちらに合わせるかを選ぶ（D21 決定 3、設計書 C3 ルール 2） */
export default function TripGroupAlignDialog({ mismatch, selfLabel, onChoose, onClose }: Props) {
  return (
    <Dialog open={Boolean(mismatch)} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontSize: 16 }}>どちらの車両・ドライバー・運送会社に合わせますか？</DialogTitle>
      <DialogContent>
        {mismatch && (
          <Stack spacing={1.5} sx={{ pt: 1 }}>
            <Typography sx={{ fontSize: 14 }}>
              1 便と 2 便以降は同じ車両・ドライバーで走ります。紐付け先と違うので、どちらかに合わせます。
            </Typography>
            <Button variant="outlined" onClick={() => onChoose('target')} sx={{ justifyContent: 'flex-start', textAlign: 'left' }}>
              {courseLabel(mismatch.target)} に合わせる（{describe(mismatch.target)}）
            </Button>
            <Button variant="outlined" onClick={() => onChoose('self')} sx={{ justifyContent: 'flex-start', textAlign: 'left', display: 'block' }}>
              {selfLabel} に合わせる（{describe(mismatch.self)}）
              <Box component="span" sx={{ display: 'block', fontSize: 12, color: 'text.secondary' }}>
                紐付け先の便グループ全体を書き換えます
              </Box>
            </Button>
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
      </DialogActions>
    </Dialog>
  );
}
